module.exports = __webpack_public_path__ + "img/biztalk_logo.7ca108fa.png";